import React, { useEffect, useState } from "react";
import './loapoiframe.css'
import { showToast } from './toastUtils';
import FullscreenLoader from './FullscreenLoader';
import { queuedApiFetch, apiFetch } from './api';
function Loapoiframe() {
  const [dataLoading, setDataLoading] = useState(false);
  const [LOAdataLoading, setLOADataLoading] = useState(false);
  const [itemList, setItemList] = useState([]);
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectid = selectedProjectDetail.projectNumber;
  // const getUserDetails = localStorage.getItem('userDetails');
  // const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  // const getUserAccess = userDetails ? userDetails.access_level : '';  

  //const getUserAccess = 'project_user';  
    const getUserDetails = localStorage.getItem('userDetails');
    const userDetails = getUserDetails ? JSON.parse(getUserDetails): '';
    const userId = userDetails ? userDetails.id : '';
    const userName = userDetails ? userDetails.name : '';
    
    const getUserAccess = userDetails ? userDetails.access_level : '';
    const [userCompany, setUserCompany] = useState();
    const getUserCompanyDetails =userCompany;
    const getUserEmail = localStorage.getItem('userEmail');
    const [userPermission, setUserPermission] = useState();
    const [userRoleManual, setUserRolesManual] = useState();
    const [loading, setLoading] = useState(true);
    const [editValues, setEditValues] = useState({});
    const [proj_access_level, setProjAccessLevel] = useState(false);


    const fetchUserCompany = async () => {
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
          setUserCompany(data.data.company_name);
          setUserPermission(data.data.access_level);     
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        //setLoading(false); // End loading
      }
    }
  
    const fetchUserRole = async () => {
      const requestOptions = {
        method: 'GET',
        //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
      };
       try {
        const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectid}`, requestOptions);
        const data = await response;
    
        if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual('Admin');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        //setLoading(false); // End loading
      }
    }


    const fetchData = async () => {
      try {
          await fetchUserCompany();
          await fetchUserRole();
          
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  };

  useEffect(() => {
    fetchData();
    fetchEditWBSData();
  }, []);

  const fetchEditWBSData = async () => {
    setDataLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/getwbsgroup?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const filteredData = data.data.filter(item => !(item.P_grp_id === 1 && item.P_grp_item_id === 3)) 
        .map(({ ID, Project_id, P_grp_desc, P_grp_item_desc, P_grp_wbs_value }) => ({
          ID,
          Project_id,
          P_grp_desc,
          P_grp_item_desc,
          P_grp_wbs_value
        }));
        const groupedData = filteredData.reduce((acc, item) => {
          const groupKey = `${item.P_grp_desc}||${item.P_grp_item_desc}`;

          if (!acc[groupKey]) {
            acc[groupKey] = { totalValue: 0, items: [] };
          }

          acc[groupKey].totalValue += item.P_grp_wbs_value || 0;
          acc[groupKey].items.push(item);

          return acc;
        }, {});

        const finalData = Object.keys(groupedData).map(key => {
          const [P_grp_desc, P_grp_item_desc] = key.split('||');

          return {
            P_grp_desc,
            P_grp_item_desc,
            totalValue: groupedData[key].totalValue,
            items: groupedData[key].items,
            finalValue: 0
          };
        });

        const uniqueData = finalData.filter(
          (item, index, self) =>
            index === self.findIndex((t) =>
              t.P_grp_desc === item.P_grp_desc && t.P_grp_item_desc === item.P_grp_item_desc
            )
        );

        const getloaData = await getLOAData();
        
        // console.log('getloaData', getloaData);

        const matchedData = uniqueData.map(uData => {
          if (!uData.P_grp_item_desc) return uData;
          const itemWords = uData.P_grp_item_desc.toLowerCase();
          const match = getloaData.find(gData =>
            gData.description && gData.description.toLowerCase() === itemWords)
          // return match ? { ...uData, ...match } : uData;
          return match ? { ...uData, ...match } : uData;
        });
        setItemList(matchedData);

        // console.log('matchedData...', matchedData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setDataLoading(false);
      setLoading(false); 
    }
  };

  const getLOAData = async () => {
    setLOADataLoading(true);
    const requestOptions = {
      method: "GET",
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };
    try {
      const response = await queuedApiFetch(`/funding/get_loa_po_list?projectid=${projectid}`,
        requestOptions
      );
      const data = await response;
      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        return data.data;
      } else {
        return [];
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLOADataLoading(false);
    }
  };

  const formatNumber = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return '';
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  };
  
  

  // const handleInputChange = (e, itemDes, fieldName) => {
  //   const updatedValue = e.target.value;
  //   const updatedList = itemList.map(item => {
  //     if (item.P_grp_item_desc === itemDes) {
  //       const updatedItem = { ...item, [fieldName]: updatedValue };
  //       // Recalculate finalValue only if the number input is changed
  //       // if (fieldName === "rateby_lumpsum") {
  //       //   updatedItem.finalValue = updatedValue * item.totalValue;
  //       // }
  //       return updatedItem;
  //     }
  //     return item;
  //   });
  //   setItemList(updatedList);
  // };

  const handleInputChange = (e, itemDes, fieldName) => {
    const inputValue = e.target.value.replace(/,/g, ''); // remove commas
    const updatedValue = isNaN(parseFloat(inputValue)) ? '' : parseFloat(inputValue);
  
    const updatedList = itemList.map(item => {
      if (item.P_grp_item_desc === itemDes) {
        const updatedItem = { ...item, [fieldName]: updatedValue };
        return updatedItem;
      }
      return item;
    });
  
    setItemList(updatedList);
  };
  


  const saveLoaPO = async () => {

    const formattedData = itemList.map(({ po_no, P_grp_item_desc, vendor_name, contract_no, rateby_lumpsum, interim_po_amount_wo_gst, original_budget, finalValue, totalValue, final_po_amount_wo_gst }) => ({
      project_id : projectid,
      po_no: po_no || '',
      description: P_grp_item_desc || '',
      vendor_name: vendor_name || '',
      contract_no: contract_no || '',
      // rateby_lumpsum : (!P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") && !P_grp_item_desc?.trim().toLowerCase().includes("qs fees")) ?  original_budget ? original_budget : '' : rateOrLumpSum || '',
      // interim_po_amount_wo_gst: P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") || P_grp_item_desc?.trim().toLowerCase().includes("qs fees") ? finalValue > 0 ? finalValue : totalValue : interimPOAmount || 0,
      // final_po_amount_wo_gst : finalPOAmount || 0

      rateby_lumpsum: (!P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") &&
        !P_grp_item_desc?.trim().toLowerCase().includes("qs fees"))
        ? (original_budget ? parseFloat(original_budget).toFixed(2) : 0.00)
        : (rateby_lumpsum ? parseFloat(rateby_lumpsum).toFixed(2) : 0.00),

      interim_po_amount_wo_gst: (P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") ||
        P_grp_item_desc?.trim().toLowerCase().includes("qs fees"))
        ? (finalValue > 0 ? parseFloat(finalValue).toFixed(2) :  (rateby_lumpsum>0)? parseFloat(totalValue).toFixed(2):parseFloat(totalValue).toFixed(2))
        : (rateby_lumpsum>0)? parseFloat(interim_po_amount_wo_gst).toFixed(2):parseFloat(interim_po_amount_wo_gst).toFixed(2),

      final_po_amount_wo_gst: parseFloat(final_po_amount_wo_gst || 0).toFixed(2),
    }));

    // console.log('formattedData......', formattedData);

    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(formattedData),
    };
    try {
      const response = await queuedApiFetch('/funding/insert_loa_po', requestOptions);
      const result = await response;
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Data saved successfully');
        // fetchEditWBSData();
      } else {
        showToast.error(result.apistatus.Status_Description || 'Please try again later');
      }
    } catch (error) {
      console.error('Error saving data:', error);
    } finally {
      // setFinalSubmitLoading(false);
    }
  }

  //For Permission Handling
  const isDisabled = (
    getUserCompanyDetails === 'NUS' && (
      userPermission === 'account_admin' ||
      (userPermission === 'project_admin' && (
        userRoleManual === '' ||
        userRoleManual === 'Project Manager (PM)' ||
        userRoleManual === 'Admin'
      ))
    )
  );
  
  // const access_sts = (
  //     expectedCompany,
  //     // accountAdminPermissions = [],
  //     projectAdminRoles = []
  //   ) => {
  //     const sts=(
  //       (getUserCompanyDetails === expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')  && userRoleManual?.length===0) ||        
  //       projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
  //     );
  //     return sts;
  //   };

  const access_sts = (
      expectedCompany,
      // accountAdminPermissions = [],
      projectAdminRoles = []
    ) => {
      const sts=(
        // (getUserCompanyDetails === expectedCompany && proj_access_level === true ) ||        
        projectAdminRoles.some(item=>userRoleManual?.includes?.(item))
      );
      return sts;
    };

  return (
    <div className="bodywrap">
      {loading && <FullscreenLoader />} 
      <div className="header">
        {/* {(access_sts('NUS',['Project Manager (PM)','Admin']))?(
          <button id="submit" 
        // disabled={getUserAccess == 'project_admin' ? false : true}
        // disabled={isDisabled}
        onClick={() => saveLoaPO()} >Save Changes</button>
        ):null} */}
        {/* <button id="submit" 
        disabled={getUserAccess == 'project_admin' ? false : true}
        // disabled={isDisabled}
        onClick={() => saveLoaPO()} style={{backgroundColor: (getUserAccess == 'project_admin')?'':'grey'}}>Save Changes
        </button> */}
<button id="submit" 
        // disabled={(access_sts('NUS',['Admin'])) ? false : true}
        // disabled={isDisabled}
        onClick={() => saveLoaPO()} style={{backgroundColor: (access_sts('NUS',['Project Manager (PM)','Admin']))?'':'grey'}}>Save Changes
        </button>

      </div>

      <div className="tablewrap1">
        <div id="custom-table" className="tablewrap">
          <table border="0" cellPadding="0" cellSpacing="0" width="988" style={{ borderCollapse: 'collapse', tableLayout: 'fixed', width: '741pt' }}>
            <thead>
              <tr>
                <th className="xl6918834">Description</th>
                <th className="xl6918834">Vendor Name</th>
                {/* <th className="xl6918834">LOA Ref/SAP Period Contract No.</th> */}
                <th className="xl6918834">LOA Ref</th>
                <th className="xl6918834">Rate (%)/Lump Sum</th>
                <th className="xl6918834">PO No.</th>
                <th className="xl6918834">Interim PO Amount w/o GST ($)</th>
                <th className="xl6918834">Final PO Amount w/o GST ($)</th>
              </tr>
            </thead>
            <tbody>
              {itemList && itemList.length > 0 ?
                itemList
                  .filter(item => item.P_grp_item_desc && item.P_grp_item_desc != 'null' && item.P_grp_item_desc.trim() !== "" && item.P_grp_desc !== "GST Adjustment")
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="xl7018834" style={{ width: '132pt' }}>{item.P_grp_item_desc}</td>
                      <td className="xl7018834">{item.vendor_name}</td>
                      <td className="xl7018834" style={{ width: '132pt' }}>{item.contract_no}</td>
                      <td className="xl7018834" style={{ textAlign:'center' }}>
                        {item.P_grp_item_desc?.trim().toLowerCase().includes("consultant fees") ||
                          item.P_grp_item_desc?.trim().toLowerCase().includes("qs fees") ? (
                          // <input
                          //   type="number"
                          //   style={{
                          //     border: "2px solid #ccc",
                          //     padding: "5px",
                          //     borderRadius: "4px"
                          //   }}
                          //   // onChange={(e) => handleInputChange(e, item.P_grp_item_desc)}
                          //   onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "rateOrLumpSum")}
                          // />
                          <input
                          className="custom-input"
                          // style={{
                          //       border: "2px solid #ccc",
                          //       padding: "5px",
                          //       marginTop: "15px",
                          //       borderRadius: "4px"
                          //     }}
                          defaultValue={item.rateby_lumpsum}
                          type="text"
                          onInput={(e) => {
                              const value = e.target.value;
                              if (!/^\d*$/.test(value)) {
                                e.target.value = value.replace(/\D/g, '');
                              } else {
                                handleInputChange(e, item.P_grp_item_desc, "rateby_lumpsum");
                              }
                            }}
                          />
                        ) : (item.rateby_lumpsum=='')||(item.rateby_lumpsum=='0.00')||(item.rateby_lumpsum==null) ?(
                          "Lump Sum"
                        ):(
                          item.rateby_lumpsum
                        )}
                      </td>
                      {/* (
                          item.original_budget ?? "Lump Sum"
                        ) */}
                      <td className="xl7118834">
                          <input type="text"
                          defaultValue={(item.po_no==0)||(item.po_no=='')||(item.rateby_lumpsum==null) ?'':item.po_no}
                          className='custom-input'
                          // disabled={isDisabled} 
                          disabled={(access_sts('NUS',['Admin'])) ? false : true}
                          onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "po_no")}
                         />
                      </td>
                      <td className="xl7118834">
                        {item.P_grp_item_desc?.toLowerCase().includes("consultant fees") ||
                          item.P_grp_item_desc?.toLowerCase().includes("qs fees")
                          ? (item.finalValue === 0 ? (item.totalValue) : item.finalValue)
                          :
                          // <input type="text"
                          // defaultValue={(item.interim_po_amount_wo_gst==0)||(item.interim_po_amount_wo_gst==null)  ? '':item.interim_po_amount_wo_gst}
                          //   className='custom-input'
                          //   // disabled={isDisabled} 
                          //   onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "interim_po_amount_wo_gst")}
                          // />
                          <input
                          type="text"
                          value={
                            editValues[item.P_grp_item_desc + "_interim"] ??
                            (item.interim_po_amount_wo_gst == null || item.interim_po_amount_wo_gst === 0
                              ? ''
                              : formatNumber(item.interim_po_amount_wo_gst))
                          }
                          className="custom-input"
                          disabled={(access_sts('NUS',['Project Manager (PM)'])) ? false : true}
                          onChange={(e) => {
                            const key = item.P_grp_item_desc + "_interim";
                            setEditValues(prev => ({ ...prev, [key]: e.target.value }));
                          }}
                          onBlur={(e) => {
                            const key = item.P_grp_item_desc + "_interim";
                            const rawValue = e.target.value.replace(/,/g, '');
                            handleInputChange({ target: { value: rawValue } }, item.P_grp_item_desc, "interim_po_amount_wo_gst");
                            setEditValues(prev => {
                              const copy = { ...prev };
                              delete copy[key];
                              return copy;
                            });
                          }}
                        />
                        
                        }
                      </td>
                      <td className="xl7118834">
                        {/* <input type="text"
                          defaultValue={(item.final_po_amount_wo_gst==0)||(item.final_po_amount_wo_gst=='')||(item.final_po_amount_wo_gst==null) ?'':item.final_po_amount_wo_gst}
                          className='custom-input'
                          // disabled={isDisabled} 
                          onChange={(e) => handleInputChange(e, item.P_grp_item_desc, "final_po_amount_wo_gst")}
                        /> */}
                        <input
                          type="text"
                          value={
                            editValues[item.P_grp_item_desc + "_final"] ??
                            (item.final_po_amount_wo_gst == null || item.final_po_amount_wo_gst === 0
                              ? ''
                              : formatNumber(item.final_po_amount_wo_gst))
                          }
                          className="custom-input"
                          disabled={(access_sts('NUS',['Project Manager (PM)'])) ? false : true}
                          onChange={(e) => {
                            const key = item.P_grp_item_desc + "_final";
                            setEditValues(prev => ({ ...prev, [key]: e.target.value }));
                          }}
                          onBlur={(e) => {
                            const key = item.P_grp_item_desc + "_final";
                            const rawValue = e.target.value.replace(/,/g, '');
                            handleInputChange({ target: { value: rawValue } }, item.P_grp_item_desc, "final_po_amount_wo_gst");
                            setEditValues(prev => {
                              const copy = { ...prev };
                              delete copy[key];
                              return copy;
                            });
                          }}
                        />
                      </td>
                    </tr>
                  ))
                :
                <tr>
                  <td colSpan="7" className="text-center">{dataLoading ? 'Loading...' : 'No records found'}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Loapoiframe;
